import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { stopPropagation } from '../../../../helpers/common';
import { propBool, propFunc, propShape, propStr, } from '../../../../helpers/custom-prop-types';
const SlideSearchItemCheckbox = (props) => {
    const { checked, className, item, onChange, unit, uuid } = props;
    const wrapOnChange = useCallback((e) => {
        onChange(e, item);
    }, [onChange, item]);
    return (_jsxs("label", Object.assign({ className: `slide_checkbox ${className}`, onClick: stopPropagation, role: 'presentation' }, { children: [_jsx("input", { checked: checked, className: 'item_checkbox', "data-unit": unit.value, onChange: wrapOnChange, type: 'checkbox', value: uuid }), _jsx("div", { className: 'item_checkbox_label' })] })));
};
SlideSearchItemCheckbox.propTypes = {
    checked: propBool().isRequired,
    className: propStr(),
    item: propShape().isRequired,
    onChange: propFunc().isRequired,
    unit: propShape().isRequired,
    uuid: propStr().isRequired,
};
SlideSearchItemCheckbox.defaultProps = {
    className: '',
};
export default SlideSearchItemCheckbox;
